let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("cjSd4")).then(() => parcelRequire('1cO6X'));